export default {
    showElement(element) {
        element.removeAttribute('hidden');
    },

    hideElement(element) {
        element.setAttribute('hidden', 'hidden');
    }
};
